import { apiClient } from './apiClient'
import type { RailCar, YardOccupancy } from '../types/interchange'

export const fetchYards = async () => {
  return []
}

export function getYardOccupancy(facilityId: string): Promise<YardOccupancy> {
  return apiClient.get<YardOccupancy>(`/api/v1/yards/${facilityId}/occupancy`)
}

export function getYardAssets(facilityId: string): Promise<RailCar[]> {
  return apiClient.get<RailCar[]>(`/api/v1/yards/${facilityId}/assets`)
}
